// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-block{display:flex;flex-direction:column;align-items:center;gap:8px;justify-content:center}.upload-block h2{font-size:24px;font-weight:300;color:#000;text-align:center;margin:0 6px 24px}.upload-block .uploader{height:140px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
